import React, { useCallback } from 'react'

import { ProfileViewContainer } from 'containers/Providers/ProfileView'
import { Modal } from 'components/Common'
import { Close } from 'components/Icons'

import styles from './styles'

const CareTeamModal = ({ provider, isModalOpen, setIsModalOpen }) => {
  const closeModal = useCallback(() => {
    setIsModalOpen(false)
  }, [setIsModalOpen])

  return (
    <Modal
      onClose={closeModal}
      open={isModalOpen}
      width={'75%'}
      style={styles.modal}
    >
      <Close onClick={closeModal} style={styles.closeIcon} />
      <ProfileViewContainer provider={provider} isCareTeam />
    </Modal>
  )
}

export default CareTeamModal
